<template>
  <div>
    <div class="header-tip">
      欠费条数：{{houseMoneyCount}} &nbsp;&nbsp;&nbsp;&nbsp;
      欠费金额：{{toFixed(houseMoney,2)}} &nbsp;&nbsp;&nbsp;&nbsp;
      选择房产数：{{selectHouseMoneyCount}} &nbsp;&nbsp;&nbsp;&nbsp;
      选择金额：{{toFixed(selectHouseMoney,2)}}
    </div>
    <el-table
      v-loading="loading" :data="house_bill_order" height="70vh"
      border
      style="width: 100%" @selection-change="handleSelectionChange2">
      <el-table-column type="selection" width="45" fixed></el-table-column>
      <el-table-column
        prop="h_name_date"
        label="房产信息" width="360" fixed></el-table-column>
      <el-table-column
        prop="charge_name"
        label="费项"
        width="150">
      </el-table-column>
      <el-table-column
        prop="BillDate"
        label="收费周期"
        width="150">
      </el-table-column>
      <el-table-column
        prop="charge"
        label="金额"
        width="100">
      </el-table-column>
      <el-table-column
        prop="h_name"
        label="业主">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ButlerHttp from "../Butler/common/ButlerHttp";

export default {
  name: "finance-list",
  props: {
    id: {
      type: String|Number,
      required: true,
      default: 0
    },
  },
  data() {
    return {
      house_bill_order: [],
      loading: false,
      multipleSelection2: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(){
      const that = this;
      this.loading = true;
      ButlerHttp.post("ButlerCustomer/getFinanceList",{
        customer_id:this.id
      },(res) => {
        that.loading = false;
        if(res.code){
          that.house_bill_order = res.data;
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    toFixed(num, n) {
      return Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
    }
  },
  computed:{
    houseMoney(){
      return this.house_bill_order.reduce((acc,cur)=>{
        return acc+((cur['charge']||0)*1)
      },0)
    },
    houseMoneyCount(){
      return this.house_bill_order.length
    },
    selectHouseMoney(){
      return this.multipleSelection2.reduce((acc,cur)=>{
        return acc+((cur['charge']||0)*1)
      },0)
    },
    selectHouseMoneyCount(){
      return this.multipleSelection2.length
    },
  }
}
</script>

<style lang="scss" scoped>
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/finance-list.vue